<template>
  <div
    class="apply-status-tabs px-6"
    @touchstart.stop
    @touchmove.stop
    @touchend.stop
  >
    <div
      v-for="tab in tabs"
      :key="tab.key"
      class="apply-status-tab"
      :class="{ 'is-active': activeTab === tab.key }"
      @click="$emit('change', tab.key)"
    >
      <span class="apply-status-tab-label">{{ $t(tab.label) }}</span>
      <span class="apply-status-tab-badge">{{ tab.count }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyStatusTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.apply-status-tabs {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border-bottom: 1px solid #edf0f2;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  touch-action: pan-x;
  overscroll-behavior-x: contain;
}
.apply-status-tabs::-webkit-scrollbar {
  display: none;
}
.apply-status-tab {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  padding: 12px 4px 28px;
  font-size: 16px;
  font-weight: 500;
  color: #087ef7;
  white-space: nowrap;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s;
}

.apply-status-tab.is-active {
  color: #087ef7;
  font-weight: 700;
  border-bottom-color: #087ef7;
}
.apply-status-tab-badge {
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background: #f1f3f5;
  color: #adb5bd;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.apply-status-tab.is-active .apply-status-tab-badge {
  background: #087ef7;
  color: #ffffff;
}
.apply-status-tab.is-active .apply-status-tab-label {
  color: #087ef7;
}
</style>
